import http from './httpService';

const endPoint = '/AccountingType';

export function getAccType() {
	return http.get(endPoint);
}

export default { getAccType, };